import React from "react"
import { PhotoPlaceholder } from "../photo-placeholder"
import piller from "../images/piller.png"

export function WorkshopsSection() {
  return (
    <div className="grid gap-8 md:grid-cols-3">
      <div className="md:col-span-2 space-y-6">
        <h2 className="text-2xl font-semibold">Workshops &amp; Hands-on Training (Dec’ 3, 2025)</h2>
        <ul className="grid gap-2 text-sm text-muted-foreground">
          <li>✦ 3D Printing &amp; Bioprinting</li>
          <li>✦ Biomedical Imaging</li>
          <li>✦ Medical Implants &amp; Devices</li>
          <li>✦ Material Testing</li>
        </ul>

        <div className="rounded-lg border p-4">
          <h3 className="font-medium">Special Focus</h3>
          <p className="text-sm text-muted-foreground">
            A special session will focus on 3D Printing with hands-on exposure and expert-led demonstrations.
          </p>
        </div>
      </div>
      <div className="">
        <img className="rounded-2xl" src={piller} alt="" />
      </div>
    </div>
  )
}
